<template>
  <div class="site-page about-page">
    <section class="sub-page-banner about-banner" :style="bannerStyle">
      <div class="site-container">
        <h1>关于源盛</h1>
      </div>
    </section>

    <div class="about-tabs">
      <div class="tab-bar">
        <button
          v-for="item in tabs"
          :key="item.key"
          type="button"
          :class="{ active: currentTab === item.key }"
          @click="currentTab = item.key"
        >
          {{ item.label }}
        </button>
      </div>
    </div>

    <div class="site-container about-wrap">
      <template v-if="currentTab === 'intro'">
        <div class="section-card main-content-card">
          <section class="banner-card">
            <img :src="coverImage" alt="新西兰风景">
          </section>

          <section class="info-card" v-for="item in sections" :key="item.id">
            <h3>
              <img v-if="item.icon" :src="item.icon" class="section-icon" alt="">
              {{ item.title }}
            </h3>
            <p>{{ item.content }}</p>
            <div class="tag-list">
              <div v-for="(tag, tIndex) in item.tags || []" :key="tIndex" class="service-tag-row">
                <span class="service-tag-name">{{ tag.name || tag }}</span>
                <span v-if="tag.desc" class="service-tag-desc">{{ tag.desc }}</span>
              </div>
            </div>
          </section>
        </div>

        <section class="advantage-card-wrap">
          <div class="advantage-grid">
            <div class="advantage-item" v-for="item in advantages" :key="item.title">
              <div class="icon">
                <img :src="item.icon" alt="">
              </div>
              <p class="adv-title">{{ item.title }}</p>
              <p class="adv-desc" v-if="item.desc">{{ item.desc }}</p>
            </div>
          </div>
        </section>

        <section class="section-card related-card">
          <h3>相关资讯</h3>
          <ul class="related-list">
            <li v-for="item in relatedNews" :key="item.id || item.title">
              <span class="dot"></span>
              <span class="txt">{{ item.title }}</span>
            </li>
          </ul>
        </section>
      </template>

      <template v-else>
        <section class="section-card honor-card">
          <h3>荣誉资质</h3>
          <div class="honor-grid">
            <div class="honor-item" v-for="(item, index) in honors" :key="index" @click="previewHonor(item.image)">
              <img :src="item.image" alt="荣誉资质">
              <p>{{ item.title }}</p>
            </div>
          </div>
        </section>
      </template>
    </div>

    <div class="float-tools">
      <button class="tool-btn" type="button" @click="scrollTop">
        <img src="@/assets/imgs/ysgj_006@2x.png" alt="顶部">
      </button>
      <button class="tool-btn" type="button" @click="showMessage">
        <img src="@/assets/imgs/ysgj_007@2x.png" alt="咨询">
      </button>
    </div>

    <big-img v-if="showImg" :imgSrc="previewImg" @clickit="showImg = false"></big-img>
  </div>
</template>

<script>
import { getAboutData } from '@/api'
import bigImg from '../components/bigImg.vue'

import iconSec1 from '@/assets/imgs/ysgj_032@2x.png'
import iconSec2 from '@/assets/imgs/ysgj_024@2x.png'
import iconSec3 from '@/assets/imgs/ysgj_031@2x.png'
import iconSec4 from '@/assets/imgs/ysgj_028@2x.png'
import iconSec5 from '@/assets/imgs/ysgj_029@2x.png'
import iconSec6 from '@/assets/imgs/ysgj_032@2x.png'
import iconSec7 from '@/assets/imgs/ysgj_022@2x.png'

import iconAdv1 from '@/assets/imgs/ysgj_009@2x.png'
import iconAdv2 from '@/assets/imgs/ysgj_010@2x.png'
import iconAdv3 from '@/assets/imgs/ysgj_011@2x.png'
import iconAdv4 from '@/assets/imgs/ysgj_012@2x.png'

const DEFAULT_SECTION_ICONS = [iconSec1, iconSec2, iconSec3, iconSec4, iconSec5, iconSec6, iconSec7]
const DEFAULT_ADVANTAGE_ICONS = [iconAdv1, iconAdv2, iconAdv3, iconAdv4]

const DEFAULT_SECTIONS = [
  { id: 1, title: '深耕新西兰，专注所以专业', content: '源盛国际创办于2008年，是一家在中国和新西兰注册的国际化投资和移民服务机构。集团在上海和新西兰奥克兰设有公司和办公室。近二十年来，我们始终聚焦新西兰，致力于为客户提供从签证申请到海外落地的一站式解决方案。', icon: iconSec1 },
  { id: 2, title: '专业团队，权威保障', content: '源盛国际团队由经验丰富的律师、新西兰首批持牌移民顾问、会计师及投资顾问组成，并由新西兰本地各领域专业团队提供后援支持。', icon: iconSec2 },
  { id: 3, title: '全类别签证服务，精准把控', content: '作为新西兰移民签证的全类别服务机构，源盛国际的业务覆盖多个方向。', tags: ['投资移民', '商业投资工作签证', '技术移民', '父母退休/团聚移民', '配偶团聚移民', '未成年子女团聚移民', '学生签证', '工作签证', '旅游签证'], icon: iconSec3 },
  { id: 4, title: '无缝沟通，全程护航', content: '我们的移民律师和持牌顾问与新西兰移民局保持直接、顺畅的沟通渠道，能够第一时间了解政策动态。', icon: iconSec4 },
  { id: 5, title: '双核布局，服务无忧', content: '源盛国际在新西兰奥克兰和中国上海设有办公室，两地团队协同作业，确保您无论身处何地，都能享受到及时、专业的服务。', icon: iconSec5 },
  { id: 6, title: '源盛宗旨', content: '移民、投资和海外增值服务一站式平台，始终站在新西兰移民政策的前沿，努力为各界精英打造一个双赢的平台。', icon: iconSec6 },
  { id: 7, title: '源盛理念', content: '诚信、专业、稳健！', icon: iconSec7 },
]

export default {
  name: 'About',
  components: { bigImg },
  data() {
    return {
      currentTab: 'intro',
      tabs: [
        { key: 'intro', label: '公司介绍' },
        { key: 'honor', label: '荣誉资质' },
      ],
      bannerImage: '',
      coverImage: '',
      sections: DEFAULT_SECTIONS,
      serviceTags: [],
      advantages: [],
      relatedNews: [],
      honors: [],
      showImg: false,
      previewImg: '',
    }
  },
  created() {
    this.fetchAboutData()
  },
  mounted() {
    const tab = this.$route.query.tab
    if (tab === 'honor') {
      this.currentTab = 'honor'
    }
  },
  watch: {
    '$route.query.tab': {
      handler(val) {
        this.currentTab = val === 'honor' ? 'honor' : 'intro'
      },
    },
  },
  computed: {
    bannerStyle() {
      return this.bannerImage
        ? { backgroundImage: `url(${this.bannerImage})` }
        : {}
    },
  },
  methods: {
    async fetchAboutData() {
      try {
        const data = await getAboutData()
        this.bannerImage = data.banner?.image || ''
        this.coverImage = data.coverImage || ''
        const sectionsSrc = Array.isArray(data.sections) && data.sections.length ? data.sections : DEFAULT_SECTIONS
        this.sections = sectionsSrc.map((item, index) => ({
          ...item,
          icon: DEFAULT_SECTION_ICONS[index] || DEFAULT_SECTION_ICONS[0],
        }))
        this.serviceTags = Array.isArray(data.serviceTags) ? data.serviceTags : []
        this.advantages = Array.isArray(data.advantages)
          ? data.advantages.map((item, index) => ({
            ...item,
            icon: item.icon || DEFAULT_ADVANTAGE_ICONS[index] || DEFAULT_ADVANTAGE_ICONS[0],
          }))
          : []
        this.relatedNews = Array.isArray(data.relatedNews) ? data.relatedNews : []
        this.honors = Array.isArray(data.honors) ? data.honors : []
      } catch (error) {
        // 保持默认数据，不清空
      }
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showMessage() {
      this.$Message.info('在线咨询功能开发中...')
    },
    previewHonor(img) {
      this.previewImg = img
      this.showImg = true
    },
  },
}
</script>

<style scoped>
.about-banner {
  background-image: url('~@/assets/imgs/ysgj_043@2x.png');
  background-position: center;
  background-size: cover;
}

.about-tabs {
  background: #fff;
  border-bottom: 1px solid #e7edf5;
}

.about-tabs .tab-bar {
  max-width: var(--site-width);
  margin: 0 auto;
  height: 46px;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0 20px;
}

.about-wrap {
  position: relative;
  z-index: 4;
  margin-top: 20px;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.tab-bar button {
  position: relative;
  border: none;
  background: none;
  color: #7a8595;
  font-size: 14px;
  height: 100%;
  cursor: pointer;
}

.tab-bar button.active {
  color: #2d5f9f;
  font-weight: 700;
}

.tab-bar button.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: var(--site-blue);
}

.main-content-card {
  background: var(--site-card);
  border-radius: var(--site-radius);
  overflow: hidden;
  margin-bottom: 16px;
}

.banner-card {
  padding: 16px 16px 0;
  overflow: hidden;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
}

.banner-card img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

.info-card {
  margin-top: 0;
  padding: 16px 20px;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
}

.info-card + .info-card {
  border-top: none;
  position: relative;
}

.info-card + .info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: #f0f2f5;
}

.info-card h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #2d5f9f;
  margin-bottom: 10px;
  font-weight: 700;
}

.section-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: block;
}

.info-card p {
  font-size: 13px;
  color: #5e6878;
  line-height: 1.9;
}

.tag-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
}

.service-tag-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.service-tag-name {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  background: var(--site-blue);
  font-size: 12px;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
}

.service-tag-desc {
  font-size: 13px;
  color: #5e6878;
  line-height: 1.6;
}

.advantage-card-wrap {
  margin-top: 0;
  padding: 20px 0;
  margin-bottom: 16px;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.advantage-item {
  background: #fff;
  border-radius: 10px;
  text-align: center;
  padding: 16px;
  border: 1px solid #dbe4f1;
  min-height: 170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.advantage-item .icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantage-item .icon img {
  width: 80px;
  height: 80px;
}

.advantage-item .adv-title {
  font-size: 14px;
  font-weight: 700;
  color: #2d2f33;
  line-height: 1.5;
  margin-bottom: 4px;
}

.advantage-item .adv-desc {
  font-size: 12px;
  color: #5e6878;
  line-height: 1.5;
}

.related-card {
  margin-top: 0;
  padding: 20px;
  background: var(--site-card);
  border-radius: var(--site-radius);
  margin-bottom: 16px;
}

.related-card h3 {
  font-size: 16px;
  color: #425068;
  margin-bottom: 14px;
}

.related-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 24px;
}

.related-list li {
  padding: 12px 0;
  border-bottom: 1px dashed #e7edf5;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.related-list li:nth-last-child(-n+2) {
  border-bottom: none;
}

.related-list li .dot {
  display: none;
}

.related-list li .txt {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #5f6978;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-list li:hover .txt {
  color: var(--site-blue);
}

.honor-card {
  margin-top: 0;
  padding: 16px 20px;
  background: var(--site-card);
  border-radius: var(--site-radius);
  margin-bottom: 16px;
}

.honor-card h3 {
  font-size: 16px;
  color: #425068;
  margin-bottom: 14px;
}

.honor-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.honor-item p {
  text-align: center;
  font-size: 13px;
  color: #4a5463;
  margin-top: 10px;
}

.honor-item {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e6ebf2;
  transition: all 0.2s;
}

.honor-item:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.honor-item img {
  width: 100%;
  height: auto;
  display: block;
}

.float-tools .tool-btn {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  box-shadow: none;
  border: none;
}

.float-tools .tool-btn img {
  width: 46px;
  height: 46px;
}

</style>
